/* Customized for DKNY */
class XMenu extends HTMLElement {
  constructor () {
    super()
  }
  connectedCallback () {
      this.parent_links = this.querySelectorAll('.x-menu--level-1--link > a');
      this.sub_menu_links = this.querySelectorAll('.x-menu--level-1--link:not([data-x-menu--depth="1"]) > a');
      this.sub_menu_toggles = this.querySelectorAll('.x-menu--level-1--toggle');
      this.overlap_parent = parseInt(this.getAttribute('data-x-menu--overlap-parent'));
      this.header_root = document.querySelector('.header--root');
      this.sub_menu_items = [];
      this.parents_with_sub_menu = [];
      this.sub_menu_links.forEach(e => {
        var t = e.parentNode
        this.parents_with_sub_menu.push(t),
          e.parentNode
            .querySelectorAll('ul a')
            .forEach(e => this.sub_menu_items.push(e))
      });
      this.state = 'closed';
      this.activeElement = null;
      this.load();
    
      theme.utils.libraryLoader('hoverintent', theme.libraries.hoverintent, () => {
        this.listeners()
      });
  }
  disconnectedCallback () {
    this.parent_links.off('focus.XMenu'),
      this.sub_menu_links.off('touchstart.XMenu focus.XMenu'),
      this.parents_with_sub_menu.off('mouseleave.XMenu'),
      this.parents_with_sub_menu.forEach(e => {
        e.querySelectorAll(':scope > a').off('mouseenter.XMenu')
      }),
      document.off('scroll.XMenu');
  }
  load () {
    this.arrangeMegaNav(),
      //this.listeners(),
      this.checkOverlap(),
      this.resizeObserver()
  }
  listeners () {
    var xthis = this;

    // hover intent on whole header
    hoverintent(xthis.header_root,
        function(e) {
          // nothing to do
        }, function(e) {
          xthis.header_root.setAttribute('data-has-x-menu--open', false);          
      }).options({ sensitivity: 2, interval: 100, timeout: 300 });

    // hover intent on each top nav item
    var hoverOpts = {
        sensitivity: 2, // number = sensitivity threshold (must be 1 or higher)
        interval: 200, // number = milliseconds for onMouseOver polling interval
        timeout: 500 // number = milliseconds delay before onMouseOut
    };

    this.parents_with_sub_menu.forEach(li => {
      //window.console.log('parents_with_sub_menu each', li);
      hoverintent(li,
        function(j) {
            let jel = j.target;
            let parentLI = li;
          
          xthis.activeElement = parentLI;
          xthis.header_root.setAttribute('data-has-x-menu--open', true);
          xthis.slideDown(jel);

          // make sure the open item closes on scroll
          document.on("scroll.XMenu", (event) => {            
            if (xthis.activeElement != null) {
              xthis.header_root.setAttribute('data-has-x-menu--open', false);
              xthis.slideUp(xthis.activeElement);
              document.off("scroll.XMenu");
              xthis.activeElement = null;
            }
          }); 
        }, function(k) {
            let kel = k.target;
            let parentLI = li;
                
          if (xthis.activeElement == parentLI) {
            xthis.activeElement = null;
            //xthis.header_root.setAttribute('data-has-x-menu--open', false);
          }
          xthis.slideUp(kel);
          document.off("scroll.XMenu");
      }).options(hoverOpts);

      // Hide the dropdown menu when the user tabs out of it
      var lastMenuItem = li.querySelectorAll('ul > li:last-of-type > a');
      lastMenuItem = lastMenuItem[lastMenuItem.length - 1];
      //window.console.log('lastMenuItem', lastMenuItem);
      
      li.addEventListener('keydown', (e) => {
        // Hide the menu a keyboard user tabs out of it or presses Escape
        if((e.key === 'Tab' && !e.shiftKey && e.target === lastMenuItem) || e.key == 'Escape') {
          xthis.slideUp(li);
          
          // Move focus back to the menu toggle button if Escape was pressed
          if(e.key == 'Escape') {
            li.querySelector('.x-menu--level-1--toggle').focus();
          }
        }
      });
    });
    
    this.sub_menu_toggles.forEach(b => {
      b.addEventListener('click', (e) => {
        var btn = e.target;
        var link = btn.previousElementSibling; 
        var menuVisible = btn.getAttribute('aria-expanded') == 'true';
        //window.console.log('click', menuVisible, typeof menuVisible);
        if (menuVisible) {          
          xthis.slideUp(link);
        } else {
          xthis.slideDown(link);
        }        
      });
    });
  
  }
  checkOverlap () {
    if (theme.utils.isTouchDevice && 'large' !== theme.mqs.current_window) {
      return (
        this.setAttribute('data-x-menu--overlap', !0),
        this.header_root.setAttribute('data-x-menu--overlap', !0),
        window.trigger('theme:XMenu:loaded'),
        !1
      )
    }
    this.setAttribute('data-x-menu--overlap', !1),
      this.header_root.setAttribute('data-x-menu--overlap', !1)
    let e = this
    1 === this.overlap_parent
      ? (e = e.parentNode)
      : 2 === this.overlap_parent && (e = e.parentNode.parentNode)
    var t,
      r,
      s,
      n,
      a = e.parentNode,
      i = e.index()
    let o = !1,
      l = (1 < i && (o = a.children[i - 1]), !1)
    i + 1 < a.children.length && (l = a.children[i + 1]),
      o &&
        ((r =
          (t = o.querySelector(':scope > :last-child')).offset().left +
          t.offsetWidth),
        e.offset().left - 1 <= r) &&
        (this.setAttribute('data-x-menu--overlap', !0),
        this.header_root.setAttribute('data-x-menu--overlap', !0)),
      l &&
        ((n =
          (s = e.querySelector(':scope > :last-child')).offset().left +
          s.offsetWidth),
        l.offset().left - 1 <= n) &&
        (this.setAttribute('data-x-menu--overlap', !0),
        this.header_root.setAttribute('data-x-menu--overlap', !0)),
      window.trigger('theme:XMenu:loaded')
  }
  resizeObserver () {
    new ResizeObserver(() => this.checkOverlap()).observe(this.header_root)
  }
  arrangeMegaNav () {
    var e = this.querySelectorAll('.x-menu--single-parents')
    0 === this.parents_with_sub_menu.length ||
      0 < e.length ||
      this.querySelectorAll(
        '[data-x-menu--depth="3"] .x-menu--level-2--container'
      ).forEach(e => {
        var t = e.querySelectorAll('[data-x-menu--single-parent="true"]')
        if (t.length) {
          const s = new DocumentFragment()
          t.forEach(e => s.appendChild(e))
          var r = theme.utils.parseHtml(
            '<div class="x-menu--single-parents"><ul></ul></div>'
          )
          r.querySelector('ul').appendChild(s), e.prepend(r)
        }
      })
  }
  slideDown (link, status = false) {
    //window.console.log('slideDown',link);
    var li = link.parentNode;
    var toggleButton = link.nextElementSibling;
    li.setAttribute('data-x-menu--open', true);
    link.setAttribute('aria-expanded', true);
    if (toggleButton) {
      toggleButton.setAttribute('aria-expanded', true);
    }
    this.state = 'opened';
    const dropmenu = li.querySelector('.x-menu--level-2--container');
    dropmenu && (
      dropmenu.removeAttribute('style'),
      setTimeout(() => dropmenu.setAttribute('aria-hidden', false), 0)
    );
  }
  slideUp (el) {
    //window.console.log('slideUp', el);
    var openLI, link;
    var currentTarget = el;
    if (currentTarget.classList.contains('x-menu--level-1--link')) {
      openLI = currentTarget;
      link = openLI.querySelector('a');
    } else {
      openLI = currentTarget.closest('.x-menu--level-1--link');
      link = openLI.querySelector('a');      
    }
    var toggleButton = link.nextElementSibling;
    if (openLI) {
        openLI.setAttribute('data-x-menu--open', false);
        link && link.setAttribute('aria-expanded', false);
        if (toggleButton) {
          toggleButton.setAttribute('aria-expanded', false);
        }
        //this.header_root.setAttribute('data-has-x-menu--open', false);
        this.state = 'closing';
        const dropmenu = openLI.querySelector('.x-menu--level-2--container');
        //window.console.log('slideUp dropmenu', dropmenu);
        dropmenu && (
            dropmenu.setAttribute('aria-hidden', true),
           (this.state = 'closed'),
           (dropmenu.style.display = 'none')
        );
    } else {
      //window.console.log('slideUp no openLI');
    }
  }
}

class XMenuExtension extends XMenu {
  connectedCallback () {
    ;(this.hide_when_overlapping = document.querySelectorAll(
      '.header--root .layout--login, .header--root .popup--open, .header--root .cart-link, .header--root .header--search, .header--root .header--country-selector'
    )),
      super.connectedCallback()
  }
  load () {
    super.load(), this.alignSubmenus()
  }
  alignSubmenus () {
    const t = document.querySelector('.header--root .logo--root').offsetWidth
    var e = this.querySelectorAll(
      '[data-x-menu--depth="3"] .x-menu--level-2--container'
    )
    e.length &&
      e.forEach(e => {
        ;(e.style.left = t + 'px'), (e.style.width = `calc(100% - ${t}px)`)
      })
  }
  checkOverlap () {
    var e = document.querySelector('.header--root')
    e.setAttribute('data-menu-overlap', !1),
      this.hide_when_overlapping.forEach(e => e.removeAttribute('style')),
      super.checkOverlap(),
      'true' === this.getAttribute('data-x-menu--overlap') &&
        (e.setAttribute('data-menu-overlap', !0),
        this.hide_when_overlapping.forEach(e => (e.style.display = 'none')))
  }
}
customElements.define('x-menu-root', XMenuExtension)
